import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { CookieService } from 'ngx-cookie-service';
import { HttpService } from './HttpService';
import { Router } from '@angular/router';



@Injectable()
export class AuthService {
    constructor(public localStorage: LocalStorageService, private http: HttpService, private router: Router) { }

    isAuthenticated(): boolean {
        if (this.localStorage.get('user-roles') == null || this.localStorage.get('user-identity') == null
            || this.localStorage.get('token') == null) {
            return false;
        }
        return true;
    }

    logOut() {
        this.http.get('authorization/logout')
        .subscribe(() => {
            this.router.navigate(['/signin']);
            this.localStorage.remove('user-identity');
            this.localStorage.remove('user-roles');
            this.localStorage.remove('token');
        });
    }
}
